<template>
    <div class="row">
        <div class="col-lg-12 m-b-20 client-blacklist-title">
            <!-- <h3>Idenfo's Black List Data</h3> -->
            <h3>{{ title }}</h3>
        </div>
        <div class="col-lg-8">
            <b-form v-if="status == 'completed'">
                <base-upload-file
                    :type="type"
                    :import-file-run="importFileRun"
                    :accept-file="acceptFile"
                    :label-val="'UPLOAD FILES'"
                    @show-progress="showProgress"
                >
                    <slot style="z-index: -6">
                        <div class="file-detail">
                            <div class="file-title">
                                <h5>
                                    Click here or drag &amp; drop data file here
                                    to upload
                                </h5>
                                <p>
                                    Supported file formats are XLS, XLSX and CSV
                                </p>
                            </div>
                        </div>
                    </slot>
                </base-upload-file>
                <base-toast></base-toast>
                <div class="file-activity">
                    <div class="file-thumbnail">
                        <excel-icon></excel-icon>
                    </div>
                    <div class="file-progress">
                        <h6>Uploading</h6>
                        <b-progress
                            :value="progressValue"
                            :max="max"
                            class="mb-3"
                        ></b-progress>
                        <span>{{ progressValue }}% completed</span>
                    </div>
                </div>
                <div
                    v-if="type == 'import' || type == 'deltaListUploading'"
                    class="file-upload-info"
                >
                    <div class="file-last-update">
                        <p>
                            Last updated on
                            <span>{{
                                updated_date ? updated_date : 'Not updated'
                            }}</span>
                        </p>
                    </div>
                    <div
                        v-if="updated_date && type == 'import'"
                        class="download-current-file"
                    >
                        <button
                            class="btn btn-link"
                            @click.prevent="startDownload()"
                        >
                            <i class="icon-export"></i>

                            <span class="btn-text"
                                >Download Current Data File</span
                            >
                        </button>
                    </div>
                </div>
            </b-form>
            <div v-if="status == 'in-process'" class="upload-files h-100px">
                <div class="file-detail">
                    <div class="file-title">
                        <h5 class="m-b-0px">
                            File in process, you can't upload the file.
                        </h5>
                    </div>
                </div>
            </div>
            <!-- When data is loading -->
            <base-table-spinner v-if="showPageLoader"></base-table-spinner>
        </div>
        <div
            v-if="type == 'import' || type == 'deltaListUploading'"
            class="col-lg-4"
        >
            <div class="download-template">
                <h5>Download Template</h5>
                <p>
                    To upload the black list people records into the system,
                    please download the template file. This will help you
                    understand the fields required. You can fill it up and
                    upload it back into the system.
                </p>
                <div class="link-action">
                    <div class="file-thumbnail">
                        <excel-icon></excel-icon>
                    </div>
                    <a
                        href="/files/template.xlsx"
                        download
                        class="btn btn-link porto-button"
                        >Download Template</a
                    >
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import excelIcon from '@/components/icons/ExcelIcon.vue'
//import black from '@/components/icons/Black.json'
import axios from 'axios'
const apiUrl_data = process.env.VUE_APP_API_URL
const headers = {
    Authorization: `Bearer ${localStorage.getItem('vueauth_token')}`,
}
export default {
    components: {
        excelIcon,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        title: {
            default: 'Idenfo Black List Data',
        },
        type: {
            default: 'import',
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            uploadFileCss: true,
            blacklist: false,
            progressValue: 0,
            max: 100,
            form: {
                file: null,
            },
            updated_date: null,
            url: '',
            import_statistics_data: '',
            DowmLoadFileName: '',
            status: '',
            importFileRun: true,
            acceptFile: '.xlsx,.csv,.xls',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'user',
            'dataSegmentId',
            'formBuilderList',
            'loading',
            'showPageLoader',
        ]),
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.$store.commit('showPageLoader', true)
                this.importStatisticsData()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.$store.commit('showPageLoader', true)
        this.importStatisticsData()
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        showProgress(value) {
            this.progressValue = value
        },

        forceFileDownload(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', this.DowmLoadFileName)
            document.body.appendChild(link)
            link.click()
        },

        startDownload() {
            axios({
                method: 'get',
                url: this.url,
                responseType: 'arraybuffer',
                headers: headers,
            })
                .then((response) => {
                    this.forceFileDownload(response)
                })
                .catch(() => console.log('error occured'))
        },
        async importStatisticsData() {
            let dataSegmentId = this.dataSegmentId
            if (dataSegmentId) {
                try {
                    let response = await axios.get(
                        apiUrl_data +
                            'screening-data/import-statistics/' +
                            dataSegmentId,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem(
                                    'vueauth_token'
                                )}`,
                            },
                        }
                    )
                    this.updated_date = response.data.data.lastUpdatedAt
                    this.url = response.data.data.fileURL
                    this.DowmLoadFileName = response.data.data.fileName
                    this.status = response.data.data.status
                } catch (e) {
                    this.updated_date = null
                    this.url = ''
                    this.DowmLoadFileName = ''
                    this.status = 'completed'
                }
            }

            this.$store.commit('showPageLoader', false)
        },
        // async importDeltaData() {
        //     let dataSegmentId = this.dataSegmentId
        //     if (dataSegmentId) {
        //         try {
        //             let response = await axios.post(
        //                 apiUrl_data +
        //                     'screening-data/importDelta/' +
        //                     dataSegmentId,
        //                 {
        //                     headers: {
        //                         'Content-Type': 'application/json',
        //                         Authorization: `Bearer ${localStorage.getItem(
        //                             'vueauth_token'
        //                         )}`,
        //                     },
        //                 }
        //             )
        //             this.updated_date = response.data.data.lastUpdatedAt
        //             this.url = response.data.data.fileURL
        //             this.DowmLoadFileName = response.data.data.fileName
        //             this.status = response.data.data.status
        //         } catch (e) {
        //             this.updated_date = null
        //             this.url = ''
        //             this.DowmLoadFileName = ''
        //             this.status = 'completed'
        //         }
        //     }

        //     this.$store.commit('showPageLoader', false)
        // },
    }, // End of Component > watch
} // End of export default
</script>
